import { render, staticRenderFns } from "./ProfileAppointments.vue?vue&type=template&id=8dcef866&scoped=true"
import script from "./ProfileAppointments.vue?vue&type=script&lang=js"
export * from "./ProfileAppointments.vue?vue&type=script&lang=js"
import style0 from "./ProfileAppointments.vue?vue&type=style&index=0&id=8dcef866&prod&lang=scss&scoped=true"
import style1 from "./ProfileAppointments.vue?vue&type=style&index=1&id=8dcef866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcef866",
  null
  
)

export default component.exports